import { MainCardContainer, TagComponent, TitleSection } from "./styled";

import { styled, useTheme } from "@mui/system";

import { Typography, Skeleton, Tooltip } from "@mui/material";
import { PriceComponent } from "components/Shared/Dashboard/styled";
import { formatPrice } from "helpers/dataFormat";
import { useEffect, useState } from "react";
import BasicButton from "components/BasicInputs/BasicButton";
import { InfoRounded } from "@mui/icons-material";
import { store } from "store/store";
import { apiGetCountSaleBuy } from "api/reportApi";
import { apiSetAlert } from "api/appApi";

const MainSectionContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  padding: "16px",
}));
const MainSection = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  backgroundColor: "#f9fafe",
  borderRadius: theme.shape.borderRadius,
  padding: "24px",
  display: "grid",
  gridTemplateRows: "40% 50%",
  gridGap: "5%",
}));

const FactorItemContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "grid",
  gridTemplateRows: "50% 50%",
}));
const SubItemTitleContainer = styled("div")(({ theme }) => ({
  borderBottom: `solid 3px #E0E0E0`,
  height: "55px",
}));

const SubItemTitleText = styled("div")(({ theme }) => ({
  display: "flex",
}));
const SubItemItemTitleText = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "140px",
}));
const SubItemBodyContainer = styled("div")(({ theme }) => ({
  width: "100%",
  marginBottom: "10px",
  height: "100%",
  display: "grid",
  gridTemplateColumns: "50% 50%",
}));
const SubItemItemContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
}));

const FactorItem = ({
  type,

}: {
  type: "buy" | "sale";

}) => {
  const theme = useTheme();
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({
    totalAmountPastDueDateSaleBuy: 0,
    totalAmountUnpaidSaleBuy: 0,
    countUnpaidSaleBuy: 0,
    countPastDueDateSaleBuy: 0,
  })
  const { dispatch } = store
  const getMoreInfo = (type: "buy" | "sale") => {
    const personId = location.search.split("=")[1];
    if (!personId) {
      return dispatch(apiSetAlert("ابتدا شخص ورد نظر را انتخاب نمایید", "error"));

    }
    setLoading(false)
    dispatch(apiGetCountSaleBuy({
      type, personId: personId, callBack: (res: any) => {
        setData({
          countPastDueDateSaleBuy: res.data.countPastDueDateSaleBuy,
          countUnpaidSaleBuy: res.data.countUnpaidSaleBuy,
          totalAmountPastDueDateSaleBuy: res.data.totalAmountPastDueDateSaleBuy,
          totalAmountUnpaidSaleBuy: res.data.totalAmountUnpaidSaleBuy,
        })
        setLoading(true)
      }
    }))
  }
  const personId = location.search.split("=")[1];
  useEffect(() => {
    setLoading(false)

    return () => {

    }
  }, [personId])

  return (
    <FactorItemContainer>
      <SubItemTitleContainer>
        <SubItemTitleText>
          <Tooltip title={`برای مشاهده جزئیات فاکتور${type === "sale" ? "فروش" : "خرید"}کلیک نمایید`}>
            <BasicButton onClick={() => {
              getMoreInfo(type)
            }}>
              <InfoRounded />
              <Typography variant="h6">فاکتور&nbsp;</Typography>
              <Typography
                color={type === "sale" ? theme.palette.error.main : theme.palette.success.main}
                variant="h6"
              >
                {type === "sale" ? "فروش" : "خرید"}
              </Typography>
            </BasicButton>
          </Tooltip>
        </SubItemTitleText>
      </SubItemTitleContainer>
      {
        !loading ? <Skeleton /> :

          <SubItemBodyContainer>
            <SubItemItemContainer>
              <SubItemItemTitleText>
                <Typography color={theme.palette.disabled.main}>پرداخت نشده</Typography>
                <TagComponent title={data.countUnpaidSaleBuy} />
              </SubItemItemTitleText>
              <PriceComponent price={formatPrice(data.totalAmountUnpaidSaleBuy)} />
            </SubItemItemContainer>
            <SubItemItemContainer>
              <SubItemItemTitleText>
                <Typography color={theme.palette.disabled.main}>سررسید نشده</Typography>
                <TagComponent title={data.countPastDueDateSaleBuy} />
              </SubItemItemTitleText>
              <PriceComponent price={formatPrice(data.totalAmountPastDueDateSaleBuy)} />
            </SubItemItemContainer>
            <SubItemItemContainer></SubItemItemContainer>
          </SubItemBodyContainer>
      }
    </FactorItemContainer>
  );
};

const FactorSection = () => {
  return (
    <MainCardContainer>
      <TitleSection />
      <MainSectionContainer>
        <MainSection>
          <FactorItem

            type="sale"
          />
          <FactorItem

            type="buy"
          />
        </MainSection>
      </MainSectionContainer>
    </MainCardContainer>
  );
};

export default FactorSection;
